"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Card_1 = require("@material-ui/core/Card");
var Grid_1 = require("@material-ui/core/Grid");
var Link_1 = require("@material-ui/core/Link");
var Typography_1 = require("@material-ui/core/Typography");
var withStyles_1 = require("@material-ui/styles/withStyles");
var graphql_tag_1 = require("graphql-tag");
var Routing_1 = require("src/Routing");
var styles_1 = require("./styles");
exports.ProductCardFragmentGQL = graphql_tag_1.default(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  fragment ProductCardFragment on Book {\n    id\n    imageUrl\n    title\n    displaySubtitle\n    product {\n      price\n      slug\n    }\n  }\n"], ["\n  fragment ProductCardFragment on Book {\n    id\n    imageUrl\n    title\n    displaySubtitle\n    product {\n      price\n      slug\n    }\n  }\n"])));
var ProductCard = function (props) {
    var bookData = props.bookData, classes = props.classes;
    var product = bookData.product, title = bookData.title, imageUrl = bookData.imageUrl, displaySubtitle = bookData.displaySubtitle;
    if (product === null) {
        return null;
    }
    var slug = product.slug, price = product.price;
    var displayPrice = price && "$" + price.toFixed(2);
    return (React.createElement(Grid_1.default, { item: true },
        React.createElement(Link_1.default, { component: Routing_1.RouterLink("/products/" + slug), className: classes.productCardLink },
            React.createElement(Card_1.default, { className: classes.productCard },
                React.createElement("div", { style: { height: 330, overflow: 'hidden' } }, imageUrl && React.createElement("img", { src: imageUrl, alt: title || '', style: { width: '100%' } })),
                React.createElement(Grid_1.default, { container: true, direction: "column", className: classes.infoBlock },
                    React.createElement(Grid_1.default, { item: true },
                        React.createElement(Typography_1.default, { className: classes.productName, variant: "h6" }, title)),
                    React.createElement(Grid_1.default, { container: true, className: classes.authorPriceLine },
                        React.createElement(Grid_1.default, { item: true, className: classes.courseOrAuthors },
                            React.createElement(Typography_1.default, { variant: "subtitle2" }, displaySubtitle)),
                        React.createElement(Grid_1.default, { item: true, className: classes.price },
                            React.createElement(Typography_1.default, { variant: "subtitle2" }, displayPrice))))))));
};
exports.default = withStyles_1.default(styles_1.default)(ProductCard);
var templateObject_1;
